import React from 'react';
import { Box } from '@indeed/ifl-components';

export interface HeroProps extends React.ComponentProps<typeof Box> {
    /**
     * Description for the illustration
     */
    desc?: string;
    /**
     * Aria-label for the illustration
     */
    label?: string;
    /**
     * Ref for the illustration container
     */
    ref?: React.Ref<HTMLDivElement>;
    /**
     * Title for the illustration
     */
    title?: string;
}

const Hero = React.forwardRef<HTMLDivElement, React.PropsWithChildren<HeroProps>>(
    ({ children, desc, label, title, ...rest }, forwardedRef: React.Ref<HTMLDivElement>) => {
        const svgStyles = {
            blockSize: 'auto',
            inlineSize: '100%',
            maxBlockSize: '100%',
            maxInlineSize: '100%',
        };

        return (
            <Box
                {...rest}
                ref={forwardedRef}
                sx={{
                    ...svgStyles,
                    svg: svgStyles,
                    ...rest.sx,
                }}
            >
                {React.Children.map(children, (child) =>
                    React.cloneElement(
                        child as React.ReactSVGElement,
                        label || title
                            ? {
                                  'aria-label': label,
                                  desc,
                                  role: 'img',
                                  title,
                              }
                            : {
                                  'aria-hidden': true,
                              },
                    ),
                )}
            </Box>
        );
    },
);

Hero.displayName = 'Hero';
export default Hero;
